import { useEffect, useState } from 'react';
import { useGetParams } from './useGetParams';

export const useScrollText = (
  contentRef,
  contentContainerRef,
  msgId,
  setDelay
) => {
  const [animatedPositionX, setAnimatedPositionX] = useState(0);

  const { scrollSpeed, scrollDelayStart, scrollDelayEnd, duration } =
    useGetParams();

  useEffect(() => {
    if (!contentRef.current || !contentContainerRef.current) return;

    const allWidth = contentContainerRef.current.scrollWidth;
    const initialTextWidth = contentRef.current.clientWidth;

    // 40 - margin в MessageContent.module.css
    if (allWidth > initialTextWidth + 40) {
      const needAnimatedWidth = allWidth - initialTextWidth;

      const newAnimatedDuration = needAnimatedWidth / scrollSpeed;

      // console.log('allWidth', allWidth);
      // console.log('needAnimatedWidth', needAnimatedWidth);
      // console.log('newAnimatedDuration', newAnimatedDuration);
      // console.log('==========================================');

      const newAnimatedPositionX = -allWidth + initialTextWidth;

      setAnimatedPositionX(newAnimatedPositionX);

      const delayInterval =
        scrollDelayStart + newAnimatedDuration * 1000 + scrollDelayEnd;

      setDelay(delayInterval);
    } else {
      setDelay(duration);
      setAnimatedPositionX(0);
    }
  }, [
    msgId,
    scrollSpeed,
    duration,
    contentRef,
    contentContainerRef,
    //
    scrollDelayStart,
    scrollDelayEnd,
    setDelay,
  ]);

  return {
    animatedPositionX,
    scrollSpeed,
    scrollDelayStart,
  };
};
